import formurlencoded from 'form-urlencoded';
import _ from 'lodash';

export const encodeURI = (params) => formurlencoded(params);

export const getCurrentPath = (pathname) => pathname.split('/')[1];

const isEmptyParam = (value) => (value === null || value === undefined || value.length === 0);

export const toSearchString = (searchObject, removeEmpty = true) => (
  Object
    .entries(searchObject)
    .reduce((result, [key, value]) => {
      if (isEmptyParam(value) && removeEmpty) {
        return result;
      }

      const prefix = result.length ? '&' : '';
      const valueStr = _.isString(value) ? value : JSON.stringify(value);
      return `${result}${prefix}${key}=${encodeURIComponent(valueStr)}`;
    }, '')
);

export const toSearchObject = (searchString) => (
  searchString
    .replace(/^\?/, '')
    .split('&')
    .filter((x) => x)
    .map((param) => param.split('='))
    .reduce((result, [key, value]) => (
      { ...result, [key]: decodeURIComponent(value) }
    ), {})
);

export const getSearchObject = (history) => toSearchObject(history.location.search);

export const getSearchString = (history, key, defaultValue = null) => (
  _.get(getSearchObject(history), key, defaultValue)
);

export const updateSearchString = (history, params, removeEmpty = true) => {
  const currentParams = toSearchObject(history.location.search);
  const nextParams = { ...currentParams, ...params };
  const nextSearch = toSearchString(nextParams, removeEmpty);
  history.push({ ...history.location, search: nextSearch });
};

export const searchStringChanged = (
  history,
  queryParams,
  param,
  stateAttr = null,
  parseFun = (x) => (x),
  defaultValue = null,
) => {
  const attr = stateAttr || param;
  const value = _.get(queryParams, attr, defaultValue);
  const nextValue = getSearchString(history, param, defaultValue);

  return parseFun(value) !== parseFun(nextValue);
};

export const anySearchStringChanged = (history, queryParams, checkers) => (
  _.some(Object.entries(checkers), ([param, opts]) => (
    searchStringChanged(
      history,
      queryParams,
      param,
      opts.stateAttr,
      opts.parseFun,
      opts.defaultValue,
    )
  ))
);
